/**
 * Email is an alias for a string.
 *
 * While there may be a way to eventually create a more restricted type,
 * this serves for now to signal developer intent.
 */
export type Email = string;
